<template>
  <v-card>
    <v-tabs
      :vertical="$vuetify.breakpoint.mdAndUp"
    >
      <v-tab>
        {{ firstTabLabel() }}
      </v-tab>
      <v-tab
        v-if="isCompanyAccount() && hasStripeAccount"
        :disabled="!account"
      >
        Ownership
      </v-tab>
      <v-tab
        v-if="hasStripeAccount"
      >
        Bank Accounts
      </v-tab>
<!--      <v-tab-->
<!--        v-if="hasStripeAccount"-->
<!--      >-->
<!--        Cards-->
<!--      </v-tab>-->
      <v-tab
        v-if="hasStripeAccount"
      >
        Payouts
      </v-tab>
      <v-tab
        v-if="hasStripeAccount"
      >
        Settings
      </v-tab>

      <v-tab-item>
        <account-info
          v-if="hasStripeAccount && account"
          :account="account"
        />

        <account-create-card
          v-if="!hasStripeAccount"
        />
      </v-tab-item>

      <v-tab-item
        v-if="isCompanyAccount() && hasStripeAccount"
      >
        <account-owner-info
          :account="account"
        />
      </v-tab-item>

      <v-tab-item>
        <external-account-list />
      </v-tab-item>

<!--      <v-tab-item>-->
<!--        <customer-cards-->
<!--          :is-platform="true"-->
<!--          :customer-id="customer.id"-->
<!--          :default-source="getDefaultPaymentMethod()"-->
<!--        />-->
<!--      </v-tab-item>-->

      <v-tab-item>
        <payout-table
        />
      </v-tab-item>

      <v-tab-item>
        <account-settings
          :account="account"
        />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { get, isEmpty } from 'lodash'
import AccountInfo from '@/components/Account/AccountInfo.vue'
import AccountOwnerInfo from '@/components/Account/AccountOwnerInfo.vue'
import AccountOrders from '@/components/Account/AccountOrders'
import AccountCreateCard from '@/components/Account/AccountCreateCard'
import CustomerCards from "../Customer/CustomerCards"
import ExternalAccountList from "../ExternalAccount/ExternalAccountList"


import { unixToReadableDate } from "../../services/util.service"
import AccountSettings from "./AccountSettings"
import PayoutTable from "../Payout/PayoutTable"

export default {
  components: {
    PayoutTable,
    AccountSettings,
    CustomerCards,
    AccountInfo,
    AccountOwnerInfo,
    AccountOrders,
    AccountCreateCard,
    ExternalAccountList
  },
  props: {
    account: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([ 'hasStripeAccount' ]),
  },
  methods: {
    getDefaultPaymentMethod() {
      return get(this.customer, 'invoice_settings.default_payment_method', '')
        || get(this.customer, 'default_source', '')
    },
    isCompanyAccount() {
      return get(this.account, 'business_type') === 'company'
    },
    firstTabLabel() {
      if (this.hasStripeAccount) {
        return this.isCompanyAccount() ? 'Company Account' : 'Individual Account'
      } else {
        return 'New Account'
      }
    }
  }
}
</script>
